import { render } from "./App.vue?vue&type=template&id=72258da1&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72258da1&lang=scss&scope=true"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/coral-cookie/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__